export default __webpack_public_path__ + "static/media/4.6f082d5d.png";